import React, { ReactElement, ReactNode } from "react";
import SvgIcon from "components/Common/SvgIcon";
import classnames from "classnames";
import InfoTooltip from "components/Common/InfoTooltip";
import "./style.scss";

const BLOCK_NAME = "Checkbox";

interface ComponentProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  handleToggle(value: boolean): void;
  isSwitch?: boolean;
  label?: ReactNode;
  labelSide?: "right" | "left";
  showInfoToolTip?: boolean;
  size?: "medium" | "small";
  theme?: "light" | "dark";
}

class Checkbox extends React.PureComponent<ComponentProps> {
  static defaultProps = {
    isSwitch: false,
    labelSide: "right",
    showInfoToolTip: false,
    size: "medium",
    theme: "light"
  };

  constructor(props: ComponentProps) {
    super(props);

    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  /**
   * Handlers
   */

  /**
   * Methods
   */


  /**
   * creates a tooltip element
   */
  static getTooltip(isToolTipVisible: boolean): ReactElement {
    if (isToolTipVisible) {
      return (
        <InfoTooltip
          blurb="Nuance Business Units are unavailable."
          iconDefault="QuestionCircle"
          iconClicked="QuestionCircleFilled"
        />
      );
    }

    return null;
  }

  /**
   *
   */
  handleToggle(): void {
    const { handleToggle, checked } = this.props;

    handleToggle(!checked);
  }

  handleKeyDown(e: React.KeyboardEvent): void {
    if (["Enter", " "].includes(e.key)) {
      this.handleToggle();
    }
  }

  render(): ReactElement {
    const {
      labelSide,
      label,
      disabled,
      className,
      checked,
      isSwitch,
      size,
      showInfoToolTip,
      theme
    } = this.props;

    const labelSideLeft = labelSide === "left";
    const labelElement = label && (
      <label className="Checkbox__label">{label}</label>
    );
    const type = isSwitch ? "switch" : "box";

    return (
      <div
        role="button"
        tabIndex={0}
        className={classnames(BLOCK_NAME, {
          [`${BLOCK_NAME}--disabled`]: disabled,
          [`${BLOCK_NAME}--small`]: size === "small",
          [`${BLOCK_NAME}--label-left`]: labelSideLeft,
          [`${BLOCK_NAME}--theme-${theme}`]: theme,
          [className]: Boolean(className)
        })}
        onKeyDown={this.handleKeyDown}
        onClick={this.handleToggle}
      >
        <div
          className={`
            Checkbox__box
            ${
      isSwitch
        ? "Checkbox__box--type-switch"
        : "Checkbox__box--type-box"
      }
            ${checked ? `Checkbox__box--type-${type}--checked` : ""}
          `}
        >
          {checked &&
            !isSwitch && (
            <SvgIcon
              icon={size === "small" ? "Checkmark" : "Checkbox"}
              customClassName="Checkbox__icon"
            />
          )}
        </div>
        {labelElement}
        {Checkbox.getTooltip(showInfoToolTip)}
      </div>
    );
  }
}

export default Checkbox;
